import Config from '../Config';
import { RestService } from './RestService';

export const ProductService = {
    getProductList: async function(){
        return RestService.get(Config.get_products_url, {})
        .then(response => response.json());
    },
    createModifyProduct: async function(new_request, header = {}, body){
        return RestService.post(`${Config.create_product}newRequest=${new_request}`, header, body)
        .then(response => response.json());
    },
    markBottled: async function(product){
        return RestService.get(`${Config.mark_product_glass}id=${product.id}`, {})
        .then(response => response.json());
    }, 
    removeProduct: async function(id, header = {}) {
        return RestService.post(`${Config.remove_product}id=${id}`, header, {})
        .then(response => response.json());
    },
    saveOrder: async function(header = {}, body){
        return RestService.post(`${Config.save_product_order}`, header, body)
        .then(response => response.json());
    },
};